import { TranslateOptions } from "i18n-js";

type Locale = "en" | "ar";

type TranslationSet = {
  [x: string]: string;
};

type Translation = {
  en: string;
  ar: string;
};

type LocaleContextType = {
  t: Translate;
  locale: Locale;
  translationObj?: TranslationUtils;
};

type TranslationUtils = {
  t: (key: string, options?: TranslateOptions) => string;
  locale: Locale;
  isRTL: boolean;
};

type Translate = (key: string, options?: Record<string, any>) => string;

export type {
  Locale,
  Translation,
  Translate,
  TranslationSet,
  LocaleContextType,
};
